/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { getEntities as getDentalExamAndTreatments } from 'app/entities/dental-exam-and-treatment/dental-exam-and-treatment.reducer';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';
import { createEntity, getEntity, reset, updateEntity } from './dental-exam-and-treatment.reducer';

export const DentalExamAndTreatmentUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const hospitals = useAppSelector(state => state.hospital.entities);
  const dentalExamAndTreatments = useAppSelector(state => state.dentalExamAndTreatment.entities);
  const dentalExamAndTreatmentEntity = useAppSelector(state => state.dentalExamAndTreatment.entity);
  const loading = useAppSelector(state => state.dentalExamAndTreatment.loading);
  const updating = useAppSelector(state => state.dentalExamAndTreatment.updating);
  const updateSuccess = useAppSelector(state => state.dentalExamAndTreatment.updateSuccess);
  const addedByTypeValues = Object.keys(AddedByType);

  const handleClose = () => {
    navigate(`/dental-exam-and-treatment${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getHospitals({}));
    dispatch(getDentalExamAndTreatments({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    values.lastUpdated = convertDateTimeToServer(values.lastUpdated);
    values.microSec = convertDateTimeToServer(values.microSec);
    values.timestampEntry = convertDateTimeToServer(values.timestampEntry);

    const entity = {
      ...dentalExamAndTreatmentEntity,
      ...values,
      hospital: hospitals.find(it => it.id.toString() === values.hospital?.toString()),
      group: dentalExamAndTreatments.find(it => it.id.toString() === values.group?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          lastUpdated: displayDefaultDateTime(),
          microSec: displayDefaultDateTime(),
          timestampEntry: displayDefaultDateTime(),
        }
      : {
          addedByType: 'DOCTOR',
          modifiedByType: 'DOCTOR',
          ...dentalExamAndTreatmentEntity,
          lastUpdated: convertDateTimeFromServer(dentalExamAndTreatmentEntity.lastUpdated),
          microSec: convertDateTimeFromServer(dentalExamAndTreatmentEntity.microSec),
          timestampEntry: convertDateTimeFromServer(dentalExamAndTreatmentEntity.timestampEntry),
          hospital: dentalExamAndTreatmentEntity?.hospital?.id,
          group: dentalExamAndTreatmentEntity?.group?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.dentalExamAndTreatment.home.createOrEditLabel" data-cy="DentalExamAndTreatmentCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.dentalExamAndTreatment.home.createOrEditLabel">
              Create or edit a DentalExamAndTreatment
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="dental-exam-and-treatment-id"
                  label={translate('tinyMedicRestApp.dentalExamAndTreatment.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalExamAndTreatment.examination')}
                id="dental-exam-and-treatment-examination"
                name="examination"
                data-cy="examination"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalExamAndTreatment.treatment')}
                id="dental-exam-and-treatment-treatment"
                name="treatment"
                data-cy="treatment"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalExamAndTreatment.groupOnly')}
                id="dental-exam-and-treatment-groupOnly"
                name="groupOnly"
                data-cy="groupOnly"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalExamAndTreatment.groupName')}
                id="dental-exam-and-treatment-groupName"
                name="groupName"
                data-cy="groupName"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalExamAndTreatment.examName')}
                id="dental-exam-and-treatment-examName"
                name="examName"
                data-cy="examName"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalExamAndTreatment.treatmentName')}
                id="dental-exam-and-treatment-treatmentName"
                name="treatmentName"
                data-cy="treatmentName"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalExamAndTreatment.active')}
                id="dental-exam-and-treatment-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalExamAndTreatment.cursor')}
                id="dental-exam-and-treatment-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalExamAndTreatment.lastUpdated')}
                id="dental-exam-and-treatment-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalExamAndTreatment.microSec')}
                id="dental-exam-and-treatment-microSec"
                name="microSec"
                data-cy="microSec"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalExamAndTreatment.timestampEntry')}
                id="dental-exam-and-treatment-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalExamAndTreatment.addedByType')}
                id="dental-exam-and-treatment-addedByType"
                name="addedByType"
                data-cy="addedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalExamAndTreatment.addedByID')}
                id="dental-exam-and-treatment-addedByID"
                name="addedByID"
                data-cy="addedByID"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalExamAndTreatment.modifiedByType')}
                id="dental-exam-and-treatment-modifiedByType"
                name="modifiedByType"
                data-cy="modifiedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.dentalExamAndTreatment.modifiedByID')}
                id="dental-exam-and-treatment-modifiedByID"
                name="modifiedByID"
                data-cy="modifiedByID"
                type="text"
              />
              <ValidatedField
                id="dental-exam-and-treatment-hospital"
                name="hospital"
                data-cy="hospital"
                label={translate('tinyMedicRestApp.dentalExamAndTreatment.hospital')}
                type="select"
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="dental-exam-and-treatment-group"
                name="group"
                data-cy="group"
                label={translate('tinyMedicRestApp.dentalExamAndTreatment.group')}
                type="select"
              >
                <option value="" key="0" />
                {dentalExamAndTreatments
                  ? dentalExamAndTreatments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/dental-exam-and-treatment" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DentalExamAndTreatmentUpdate;
